export const SET_BUSY = 'APP/KAMINKOVNIK/SET_BUSY';
export const SEARCH = 'APP/KAMINKOVNIK/SEARCH';
export const SHOW_MESSAGE = 'APP/KAMINKOVNIK/SHOW_MESSAGE';
export const HIDE_MESSAGE = 'APP/KAMINKOVNIK/HIDE_MESSAGE';
export const SHOW_CONFIRM_DIALOG = 'APP/KAMINKOVNIK/SHOW_CONFIRM_DIALOG';
export const HIDE_CONFIRM_DIALOG = 'APP/KAMINKOVNIK/HIDE_CONFIRM_DIALOG';
